import PropTypes from "prop-types";
import { useCallback, useEffect } from "react";
import { updateResponsiveState as updateResponsiveStateAction } from "app/pages/.shared/responsive/responsiveActionCreator";
import { useSelector, useDispatch } from "react-redux";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import useResponsiveState from "app/pages/.shared/responsive/useResponsiveState";

const ResponsiveStateProvider = ({ children }) => {
	const { track } = useAnalytics();
	const resolution = useSelector(state => state.resolution);
	const dispatch = useDispatch();
	const updateResponsiveState = useCallback(
		clientResolution => dispatch(updateResponsiveStateAction(clientResolution)),
		[dispatch]
	);
	const clientResolution = useResponsiveState(resolution);
	useEffect(() => {
		updateResponsiveState(clientResolution);
		if (clientResolution !== resolution) {
			track("unmatched_server_client_resolution", {
				clientResolution,
				serverResolution: resolution,
			});
		}
	}, [clientResolution]);
	return children;
};

ResponsiveStateProvider.propTypes = {
	resolution: PropTypes.string,
};

export default ResponsiveStateProvider;
